import Vue from "vue";
import VueRouter from "vue-router";

import HomeView from "../views/HomeView.vue";
import ReservationsView from "../views/ReservationsView.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
    meta: {
      title: "Home",
    },
  },
  {
    path: "/waiver",
    name: "waiver",
    meta: {
      title: "Damage Waiver",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "waiver" */ "../views/DamageWaiverView.vue"),
  },
  {
    path: "/disclaimers",
    name: "disclaimers",
    meta: {
      title: "Legal Disclaimers",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "disclaimers" */ "../views/DisclaimersView.vue"
      ),
  },
  {
    path: "/reservations",
    name: "reservations",
    meta: {
      title: "Book Now",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: ReservationsView,
  },
  {
    path: "/confirmed",
    name: "confirmed",
    meta: {
      title: "Reservation Confirmed",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "confirmed" */ "../views/ReservationConfirmedView.vue"
      ),
  },
  {
    path: "/insurance/submitted",
    name: "submittedInsurance",
    meta: {
      title: "Submitted Insurance",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "submittedInsurance" */ "../views/InsuranceSubmittedView.vue"
      ),
  },
  {
    path: "/verification/submitted",
    name: "submitted",
    meta: {
      title: "Verification Submitted",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "submitted" */ "../views/VerificationSubmittedView.vue"
      ),
  },
  {
    path: "/payment/received",
    name: "paymentReceived",
    meta: {
      title: "Payment Received",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "paymentReceived" */ "../views/PaymentReceivedView.vue"
      ),
  },
  {
    path: "/signature/received",
    name: "signatureReceieved",
    meta: {
      title: "Signature Received",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "signatureReceieved" */ "../views/SignatureReceivedView.vue"
      ),
  },
  {
    path: "/incidents",
    name: "reportIncident",
    meta: {
      title: "Report an Incident",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "reportIncident" */ "../views/ReportIncidentView.vue"
      ),
  },
  {
    path: "/redirect/verify/:id",
    name: "verify-redirect",
    meta: {
      title: "Redirecting...",
    },
    component: () =>
      import(
        /* webpackChunkName: "verify-redirecting" */ "../views/VerifyRedirectingView.vue"
      ),
  },
  {
    path: "/redirect/payment/:id",
    name: "payment-redirect",
    meta: {
      title: "Redirecting...",
    },
    component: () =>
      import(
        /* webpackChunkName: "payment-redirecting" */ "../views/PaymentRedirectingView.vue"
      ),
  },
  {
    path: "/redirect/sign/:id",
    name: "signature-redirect",
    meta: {
      title: "Redirecting...",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "sign" */ "../views/SignatureRedirecting.vue"
      ),
  },
  {
    path: "/redirect/document/:id",
    name: "document-redirect",
    meta: {
      title: "Redirecting...",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "document-redirect" */ "../views/DocumentRedirectingView.vue"
      ),
  },
  {
    path: "/partnerships/kw",
    name: "kw",
    meta: {
      title: "Keller Williams | Partnerships",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "kw" */ "../views/KwView.vue"),
  },
  {
    path: "/error",
    name: "500",
    meta: {
      title: "Internal Error",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "error" */ "../views/InternalErrorView.vue"),
  },
  {
    path: "*",
    name: "404",
    meta: {
      title: "Page Not Found",
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(
        /* webpackChunkName: "pagenotfound" */ "../views/PageNotFoundView.vue"
      ),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  // eslint-disable-next-line
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },
  routes,
});

router.afterEach((to) => {
  Vue.nextTick(() => {
    document.title = to.meta.title + " | Resla";
  });
});

export default router;
